import { render, staticRenderFns } from "./LogoLight.vue?vue&type=template&id=215752ce&scoped=true"
import script from "./LogoLight.vue?vue&type=script&lang=js"
export * from "./LogoLight.vue?vue&type=script&lang=js"
import style0 from "./LogoLight.vue?vue&type=style&index=0&id=215752ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215752ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('215752ce')) {
      api.createRecord('215752ce', component.options)
    } else {
      api.reload('215752ce', component.options)
    }
    module.hot.accept("./LogoLight.vue?vue&type=template&id=215752ce&scoped=true", function () {
      api.rerender('215752ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/LogoLight.vue"
export default component.exports